import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Sparkle light
 */

export default function SparkleLightIcon(props) {
  return (
    <Icon viewBox="0 0 18 18" {...props}>
      <path
        d="M9 1.25C8.75089 1.25 8.52188 1.39062 8.41741 1.61328L5.87812 6.96094L0.377678 9.42969C0.148661 9.53125 0.00401878 9.75391 0.00401878 9.99609C0.00401878 10.2383 0.148661 10.4609 0.377678 10.5625L5.87411 13.0391L8.41741 18.3867C8.52188 18.6094 8.75089 18.75 9 18.75C9.24911 18.75 9.47813 18.6094 9.58259 18.3867L12.1259 13.0391L17.6263 10.5664C17.8554 10.4648 18 10.2422 18 10C18 9.75781 17.8554 9.53516 17.6263 9.43359L12.1259 6.96484L9.58259 1.61328C9.47813 1.39062 9.24911 1.25 9 1.25ZM9 3.36719L11.0571 7.69531C11.1214 7.83203 11.2339 7.9375 11.3705 8L15.8223 10L11.3705 12C11.2299 12.0625 11.1214 12.1719 11.0571 12.3047L9 16.6328L6.94286 12.3047C6.87857 12.168 6.76607 12.0625 6.62946 12L2.17768 10L6.62946 8C6.77009 7.9375 6.87857 7.82812 6.94286 7.69531L9 3.36719Z"
        fill="#8C69F0"
      />
    </Icon>
  );
}
